import React from 'react';
import {
  DateRangeDropdownV2 as DateRangeField,
  DocumentNumberRangeFieldV2 as DocumentNumberRangeField,
  FormFieldV2,
  SearchFieldV2
} from '@/components/custom/erp';
import { accountSearchColumns, khachHangSearchColumns, nhanVienSearchColumns, QUERY_KEYS } from '@/constants';
import type { AccountModel, KhachHang, NhanVien } from '@/types/schemas';

interface BasicInfoTabProps {
  formMode: 'add' | 'edit' | 'view';
}

const BasicInfoTab = ({ formMode }: BasicInfoTabProps) => {
  const isViewMode = formMode === 'view';

  return (
    <div className='space-y-3 p-4'>
      <div className='flex items-center gap-2'>
        <span className='text-md min-w-36'>Ngày chứng từ</span>
        <DateRangeField toFieldClassName='w-44' fromFieldClassName='w-44' />
      </div>

      <DocumentNumberRangeField formMode={formMode} />

      <div className='grid grid-cols-[150px,1fr] items-center'>
        <span className='text-left text-sm font-normal'>Tài khoản nợ</span>
        <SearchFieldV2<AccountModel>
          name='debitAccount'
          searchEndpoint={`/${QUERY_KEYS.TAI_KHOAN}/`}
          searchColumns={accountSearchColumns}
          columnDisplay='code'
          displayRelatedField='name'
          dialogTitle='Danh mục tài khoản'
          disabled={isViewMode}
        />
      </div>

      <div className='grid grid-cols-[150px,1fr] items-center'>
        <span className='text-left text-sm font-normal'>Mã khách hàng</span>
        <SearchFieldV2<KhachHang>
          name='customerCode'
          searchEndpoint={`/${QUERY_KEYS.KHACH_HANG}/`}
          searchColumns={khachHangSearchColumns}
          columnDisplay='customer_code'
          displayRelatedField='customer_name'
          dialogTitle='Danh mục đối tượng'
          disabled={isViewMode}
        />
      </div>

      <div className='grid grid-cols-[150px,1fr] items-center'>
        <span className='text-left text-sm font-normal'>Mã nhân viên</span>
        <SearchFieldV2<NhanVien>
          name='employeeCode'
          searchEndpoint={`/${QUERY_KEYS.NHAN_VIEN}/`}
          searchColumns={nhanVienSearchColumns}
          columnDisplay='ma_nhan_vien'
          displayRelatedField='ho_ten_nhan_vien'
          dialogTitle='Danh mục nhân viên'
          disabled={isViewMode}
        />
      </div>

      <div className='grid grid-cols-[150px,1fr] items-center'>
        <span className='text-left text-sm font-normal'>Diễn giải</span>
        <FormFieldV2 name='description' type='text' disabled={isViewMode} />
      </div>
    </div>
  );
};

export default BasicInfoTab;
